/**
 * Not authorized exception
 * @param message
 * @constructor
 */
export function NotAuthorizedException(message) {
  this.message = message;
  this.code = 'UNAUTHORIZED';
}

/**
 * Access denied exception
 * @param message
 * @constructor
 */
export function AccessDeniedException(message) {
  this.message = message;
  this.code = 'ACCESS_DENIED';
}
